module.exports = __webpack_public_path__ + "img/sunrise.682276b8.svg";